import { render, staticRenderFns } from "./pnl_layout.vue?vue&type=template&id=19580bd7"
import script from "./pnl_layout.vue?vue&type=script&lang=js"
export * from "./pnl_layout.vue?vue&type=script&lang=js"
import style0 from "./pnl_layout.vue?vue&type=style&index=0&id=19580bd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports